import type { Admin } from '@/generated/graphql';

import { IUser, mapGQLUser } from './user';

export interface IAdmin {
  id: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  updatedAt: string;

  user: IUser;
}

export interface IAdminQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLAdmin(gql_admin?: Admin | null): IAdmin {
  return {
    id: gql_admin?.id ?? '',
    firstName: gql_admin ? gql_admin.firstName ?? '' : '',
    lastName: gql_admin ? gql_admin.lastName ?? '' : '',

    updatedAt: gql_admin ? gql_admin.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    user: mapGQLUser(gql_admin?.user),
    createdAt: gql_admin
      ? new Date(gql_admin.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
